export class Role{
  static DCA_IN: string = "DCA_IN";
  static DCA_MEMBER: string = "DCA_Member";
  static DCA_OPER: string = "DCA_OPER";

  id: number;
  roleName: string;
  authority: string;
}



// WEBPACK FOOTER //
// /app/src/app/shared/models/role.ts